export default __webpack_public_path__ + "static/media/1 S-6071PF3E1.1023a67b.jpg";